import { connect } from "react-redux";
import DonorDetails from "./DonorDetails";
import { updateDonor } from "../../../redux/reservations/actions";
import {
  deleteDonorDetails,
  toggleDonorDetailsModal
} from "../../../redux/users/actions";
import { toggleBookingCancelModal } from "../../../redux/timeslots/actions";

const mapDispatchToProps = {
  updateDonor,
  deleteDonorDetails,
  toggleDonorDetailsModal,
  toggleBookingCancelModal,
};

const mapStateToProps = (state) => ({
  donorDetailsData: state.usersReducer.donorDetailsData,
  isUserGetError: state.usersReducer.isError,
  isUserPending: state.usersReducer.isPending,
  isModalOpen: state.usersReducer.donorDetailsModalIsOpen,
  userRoleName: state.authReducer.roleName,
  users: state.usersReducer.users,
});

export default connect(mapStateToProps, mapDispatchToProps)(DonorDetails);
